export default __webpack_public_path__ + "static/media/manager.552b20ff.svg";